module.exports = __webpack_public_path__ + "static/media/top-filter-active-dark-icon.e2719093.svg";